/* eslint-disable react-hooks/rules-of-hooks */
import * as Unicons from '@iconscout/react-unicons';
import { useEffect, useState } from 'react';
import { Operators } from '../../../../../enum/operators.enum';
import { Predicate } from '../../../../../models/predicate.model';
import { TFunction } from 'i18next';

interface PastaFiltrosProps {
  findPasta: () => void;
  predicate: Predicate;
  t: TFunction<["common", "materiais_de_apoio"], undefined>
}
export default function FiltrosPasta({ findPasta, predicate, t }: PastaFiltrosProps) {
  const [search, setSearch] = useState<string>();

  useEffect(() => {
    const typingTimeout = setTimeout(() => {
        predicate.removeAllOption();

        if (search) {
            predicate.addOption('nome', search, Operators.CONTAINS);
        }
      
        findPasta();
    }, 800);
    return () => clearTimeout(typingTimeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [search]);
  return (
    <>
       <i className="search-bar__icon">
          <Unicons.UilSearch size={20} color="var(--dark)" />
        </i>
        <input
          className="search-bar__input"
          placeholder={t('materiais_de_apoio:searchMaterials')}
          onChange={(e) => setSearch(e.target.value)}
        />
    </>
  );
}
